import { Button } from '@cian/button-component';
import * as React from 'react';
import * as Modal from 'react-modal';
import { connect } from 'react-redux';

import { IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IContext, IState } from '../../../store';
import { IconClose } from '../assets/icon_close';

import * as styles from './index.css';

export interface IPopupCallbackStoreProps {
  offer: IOfferSchema;
  user: IUserSchema | null;
}

export interface IPopupCallbackOwnProps {
  isOpen: boolean;
  onClose(): void;
}

export type IPopupStartChatProps = IPopupCallbackStoreProps & IPopupCallbackOwnProps;

class PopupStartChatComponent extends React.Component<IPopupStartChatProps, {}> {
  public context: IContext;

  public render() {
    const { isOpen, onClose } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={onClose}
        style={{
          content: {
            backgroundColor: 'white',
            borderRadius: '4px',
            boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.22)',
            overflow: 'visible',
            padding: '24px 46px 24px 30px',
            position: 'relative',
            width: '500px',
            zIndex: 101,
          },
          overlay: {
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, .8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          },
        }}
      >
        <button className={styles['close']} onClick={onClose}>
          <IconClose />
        </button>
        <h3 className={styles['title']}>Вы не можете написать сообщение самому себе</h3>
        <div className={styles['actions']}>
          <Button onClick={onClose}>Закрыть</Button>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state: IState): IPopupCallbackStoreProps {
  return {
    offer: state.offerData.offer,
    user: state.offerData.user,
  };
}

export const PopupOwnOfferContainer = connect<IPopupCallbackStoreProps, {}, IPopupCallbackOwnProps>(mapStateToProps)(
  PopupStartChatComponent,
);
